module.exports = __webpack_public_path__ + "static/img/landingpage-hero-plus.16f7012.png";